<template>
  <div class="home">
    <van-swipe class="my-swipe" :autoplay="3000">
      <van-swipe-item><img src="../../首页/03.png" alt="" /></van-swipe-item>
      <van-swipe-item><img src="../../首页/04.png" alt="" /></van-swipe-item>
      <van-swipe-item><img src="../../首页/05.png" alt="" /></van-swipe-item>
    </van-swipe>
    <div class="img">
      <img src="../../首页/06.png" alt="" />
    </div>
    <div class="psychology">
      <img src="../../首页/10.png" alt="" />
      <h1>全方位的心理服务体验</h1>
      <img src="../../首页/09.png" alt="" class="aa" />
    </div>
    <div class="papers">
      <img src="../../首页/11.png" alt="" />
      <img src="../../首页/12.png" alt="" />
      <img src="../../首页/13.png" alt="" />
      <img src="../../首页/14.png" alt="" />
    </div>
    <van-tabs class="aaa">
      <div>
        <van-tab title="心理知识">
          <p>
            <span>心理百科</span><span>心理百科</span><span>心理技巧</span
            ><span>心理常识</span> <span>解读人生百态，了解心理真相</span>
            <span>专业名词介绍，了解心理学</span
            ><span>了解心理小技巧，生活更顺利</span>
            <span>懂得他人内心</span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span><button>人生百态</button><button>心里现象</button></span>
            <span><button>疾病知识</button><button>心理学</button></span>
            <span><button>心理暗示</button><button>情绪控制</button></span>
            <span><button>微表情</button><button>微动作</button></span>

            <span>人际关系</span><span>家庭关系</span><span>精彩故事</span
            ><span>国学经典</span> <span>做好人际关系，职场工作更顺心</span>
            <span>家庭和睦，美好生活</span><span>身边人的故事</span>
            <span>学国学，懂心理</span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span>
              <img src="../../首页/15.png" alt="" />
              热度12531
            </span>
            <span><button>朋友关系</button><button>同事关系</button></span>
            <span><button>夫妻关系</button><button>子女关系</button></span>
            <span><button>正能量</button><button>精彩人生</button></span>
            <span><button>处事之道</button><button>为人之道</button></span>
          </p>
        </van-tab>
      </div>
      <div>
        <van-tab title="评测问卷">
          <p>
            <span>健康</span><span>情感</span><span>性格</span
            ><span>事业</span> <span>专业的心理健康问卷</span>
            <span>情感自我认知评测</span><span>认清自我性格特征</span>
            <span>了解你适合的事业</span>
            <span> 收录：112卷 </span>
            <span> 收录：87卷 </span>
            <span> 收录：43卷 </span>
            <span> 收录：56卷 </span>
            <span><button>心理量表</button><button>状态体检</button></span>
            <span class="btn"
              ><button>亲情</button><button>爱情</button
              ><button>友情</button></span
            >
            <span><button>性格认知</button></span>
            <span><button>职场</button><button>创业</button></span>
            <span>社交</span><span>能力</span><span>趣味</span
            ><span>其他</span> <span>你欠缺的社交能力</span>
            <span>了解你的能力指教</span><span>网络流行测一测</span>
            <span>大众社会现象调查</span>
            <span> 收录：31卷 </span>
            <span> 收录：21卷 </span>
            <span> 收录：162卷 </span>
            <span> 收录：66卷 </span>
            <span><button>语言评测</button><button>沟通心理</button></span>
            <span><button>身体</button><button>解决问题</button></span>
            <span><button>娱乐</button><button>逻辑</button></span>
            <span><button>社会问题</button><button>社会认知</button></span>
          </p>
        </van-tab>
      </div>
      <div>
        <van-tab title="休闲减压">
          <p class="p">
            <img src="../../0114/02.png" alt="" />
          </p>
        </van-tab>
      </div>
      <div>
        <van-tab title="健康方案">
          <p class="p">
            <img src="../../0114/01.png" alt="" />
          </p>
        </van-tab>
      </div>
    </van-tabs>
    <!-- 蓝色区域 -->
    <div class="center"></div>
    <div class="psychology">
      <img src="../../首页/10.png" alt="" />
      <h1>多功能互联网智能设备</h1>
      <img src="../../首页/09.png" alt="" class="aa" />
    </div>
    <!-- 黄色区域 -->
    <div class="aside">
      <div class="imgOne">
        <img src="../../首页/16.png" alt="" />
      </div>
      <div class="run">
        <img src="../../首页/18.png" alt="" />
        <h5>智能跑步机</h5>
        <p>
          高度：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.45M
        </p>
        <p>机器净重 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;88kg</p>
        <p>最大速度 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;16KM/H</p>
        <p>最大承重 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;126kg</p>
        <p>
          长度&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.71M
        </p>
        <p>
          宽度
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0.85M
        </p>
        <button>查看更多</button>
      </div>
      <div class="lunyi">
        <img src="../../首页/19.png" alt="" />
        <h5>心理运动减压系统</h5>
        <p>1、改系统一体化设计，方便直观，多触点显示屏的3D模拟实景显示效果</p>
        <p>
          2、精度可调：在乎细微舒适度，细致入微、防滑脚蹬、扶手、等多种方式调节
        </p>
        <button>查看更多</button>
      </div>
      <div class="anmo">
        <img src="../../首页/20.png" alt="" />
        <h5>智能睡眠调节系统</h5>
        <p>
          健康监测调试系统是运用专业HRV算法，为用户呈现各项生理数据并且提供专业放松方案的生物反馈心理调适系统。系统包含健康监测、呼吸训练、减压调养、高效放松、音乐调适、档案中心六大模块。
        </p>
        <button>查看更多</button>
      </div>
      <div class="imgTwo">
        <img src="../../首页/17.png" alt="" />
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="p">
        <p>微信公众号： 师福在线</p>
        <p>QQ： 3555868615</p>
        <p>客服电话： 0316-2285999</p>
      </div>
      <div class="h">
        @2022 Jin yuan langfang century information technology co., LTD 版权所有
        备案号：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff">冀ICP备18036534号-3</a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  data() {
    return {
      activeName: "a",
    };
  },
  method: {
    // 鼠标点击事件
    dianji() {},
  },
};
</script>
<style scoped lang="scss">
.home {
  .my-swipe .van-swipe-item {
    z-index: 10000;
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    // background-color: #39a9ed;
    img {
      width: 100%;
      height: 600px;
    }
  }

  .aaa {
    width: 1000px;
    height: 50px;
    margin: 0 auto;
    // font-weight: 700;
    p {
      width: 1590px;
      height: 353px;
      background: url(../../首页/21.png) 100% 100%;
      background-size: 100% 100%;
      position: absolute;
      left: -300px;
      span {
        position: absolute;
        top: 30px;
        left: 376px;
        color: #333;
        font-weight: 700;
      }
      span:nth-child(2) {
        position: absolute;
        top: 30px;
        left: 612px;
        color: #333;
      }
      span:nth-child(3) {
        position: absolute;
        top: 30px;
        left: 876px;
        color: #333;
      }
      span:nth-child(4) {
        position: absolute;
        top: 30px;
        left: 1118px;
        color: #333;
      }
      span:nth-child(5) {
        position: absolute;
        top: 50px;
        // left: 1118px;

        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(5) {
        position: absolute;
        top: 60px;
        left: 376px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(6) {
        position: absolute;
        top: 60px;
        left: 612px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(7) {
        position: absolute;
        top: 60px;
        left: 876px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(8) {
        position: absolute;
        top: 60px;
        left: 1118px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }

      span:nth-child(9) {
        position: absolute;
        top: 90px;
        left: 376px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(10) {
        position: absolute;
        top: 90px;
        left: 612px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(11) {
        position: absolute;
        top: 90px;
        left: 876px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(12) {
        position: absolute;
        top: 90px;
        left: 1118px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(13) {
        position: absolute;
        top: 120px;
        left: 370px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
      span:nth-child(14) {
        position: absolute;
        top: 120px;
        left: 605px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
        .btn {
          width: 40px;
        }
        button {
          // width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
      span:nth-child(15) {
        position: absolute;
        top: 120px;
        left: 870px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
      span:nth-child(16) {
        position: absolute;
        top: 120px;
        left: 1110px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }

      span:nth-child(17) {
        position: absolute;
        font-weight: normal;
        top: 190px;
        left: 376px;
        color: #333;
        font-weight: 700;
      }
      span:nth-child(18) {
        position: absolute;
        top: 190px;
        left: 612px;
        color: #333;
        font-weight: normal;
        font-weight: 700;
      }
      span:nth-child(19) {
        position: absolute;
        top: 190px;
        left: 876px;
        color: #333;
        font-weight: normal;
        font-weight: 700;
      }
      span:nth-child(20) {
        position: absolute;
        top: 190px;
        left: 1118px;
        color: #333;
        font-weight: normal;
        font-weight: 700;
      }
      span:nth-child(21) {
        position: absolute;
        top: 220px;
        left: 376px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(22) {
        position: absolute;
        top: 220px;
        left: 609px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(23) {
        position: absolute;
        top: 220px;
        left: 877px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(24) {
        position: absolute;
        top: 220px;
        left: 1121px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(25) {
        position: absolute;
        top: 249px;
        left: 375px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(26) {
        position: absolute;
        top: 249px;
        left: 613px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(27) {
        position: absolute;
        top: 249px;
        left: 876px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
      }
      span:nth-child(28) {
        position: absolute;
        top: 249px;
        left: 1118px;
        font-size: 14px;
        font-weight: normal;
        color: #666666;
      }
      span:nth-child(29) {
        position: absolute;
        top: 280px;
        left: 370px;
        font-weight: normal;
        font-size: 14px;
        color: #666666;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
      span:nth-child(30) {
        position: absolute;
        top: 280px;
        left: 604px;
        font-size: 14px;
        color: #666666;
        font-weight: normal;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
      span:nth-child(31) {
        position: absolute;
        font-weight: normal;
        top: 280px;
        left: 868px;
        font-size: 14px;
        color: #666666;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
      span:nth-child(32) {
        position: absolute;
        top: 280px;
        left: 1109px;
        font-weight: normal;
        font-size: 14px;
        color: #666666;
        button {
          width: 80px;
          text-align: center;
          border: 1px solid #666666;
          background-color: rgba(235, 230, 230, 0.1);
          margin-left: 10px;
        }
      }
    }
    .p {
      img {
        width: 1000px;
        margin-left: 300px;
        margin-top: 30px;
      }
    }
  }
  .img {
    position: absolute;
    top: 20px;
    left: 290px;
  }
  .psychology {
    display: flex;
    margin: 44px auto;
    // justify-content: space-around;
    h1 {
      font-size: 30px;
      color: #1587f7;
      margin-left: 50px;
      margin-top: -8px;
      font-family: "微软雅黑";
    }
    img {
      // margin-left: 150px;
      width: 70px;
      height: 30px;
    }
    img:nth-child(1) {
      margin-left: 520px;
    }
    .aa {
      margin-left: 40px;
    }
  }
  .papers {
    margin-left: 200px;
    margin-top: -25px;
    img {
      width: 60px;
      height: 60px;
      margin-left: 185px;
    }
    img:nth-child(2) {
      width: 60px;
      height: 60px;
      margin-left: 192px;
    }
    img:nth-child(3) {
      width: 60px;
      height: 60px;
      margin-left: 192px;
    }
    img:nth-child(4) {
      width: 60px;
      height: 60px;
      margin-left: 190px;
    }
  }
  .center {
    width: 100%;
    height: 350px;
  }
  .aside {
    display: flex;
    width: 100%;
    height: 400px;
    margin-top: -30px;
    .imgOne {
      position: absolute;
      top: 1470px;
      left: 130px;
    }
    .imgTwo {
      position: absolute;
      top: 1470px;
      right: 130px;
    }
    .run {
      width: 260px;
      height: 400px;
      box-shadow: 0px 0px 11px 0px #aaa;
      margin-left: 300px;
      img {
        width: 220px;
        height: 150px;
        margin-left: 20px;
        margin-top: 20px;
        text-align: center;
      }
      h5 {
        text-align: center;
        font-family: "微软雅黑";
      }
      P {
        margin-left: 70px;
        font-size: 12px;
        margin-top: -8px;
        color: #666;
      }
      button {
        background-color: #fff;
        // text-align: center;
        margin-left: 80px;
        margin-top: 5px;
        width: 100px;
        height: 30px;
        color: #1587f7;
        border: 1px solid #1587f7;
        font-size: 14px;
        border-radius: 15px;
      }
    }
    .lunyi {
      width: 260px;
      height: 400px;
      box-shadow: 0px 0px 11px 0px #aaa;
      margin-left: 100px;
      img {
        width: 220px;
        height: 150px;
        margin-left: 20px;
        margin-top: 20px;
        text-align: center;
      }
      h5 {
        text-align: center;
      }
      P {
        margin-left: 30px;
        font-size: 12px;
        margin-top: -8px;
        color: #666;
        margin-right: 30px;
        margin-top: 10px;
      }
      button {
        background-color: #fff;
        // text-align: center;
        margin-left: 80px;
        margin-top: 20px;
        width: 100px;
        height: 30px;
        color: #1587f7;
        border: 1px solid #1587f7;
        font-size: 14px;
        border-radius: 15px;
      }
    }
    .anmo {
      width: 260px;
      height: 400px;
      box-shadow: 0px 0px 11px 0px #aaa;
      margin-left: 100px;
      img {
        width: 220px;
        height: 150px;
        margin-left: 20px;
        margin-top: 20px;
        text-align: center;
      }
      h5 {
        text-align: center;
        font-family: "微软雅黑";
      }
      P {
        margin-left: 30px;
        font-size: 12px;
        margin-top: -8px;
        color: #666;
        margin-right: 30px;
        margin-top: 10px;
      }
      button {
        background-color: #fff;
        // text-align: center;
        margin-left: 80px;
        margin-top: 20px;
        width: 100px;
        height: 30px;
        color: #1587f7;
        border: 1px solid #1587f7;
        font-size: 14px;
        border-radius: 15px;
      }
    }
  }
  .footer {
    margin-top: 20px;
    width: 100%;
    height: 80px;
    background-color: #1587f7;
    .p {
      display: flex;
      justify-content: space-around;
      color: #fff;
      font-size: 18px;
    }
    p:nth-child(1) {
      margin-left: 60px;
    }
    p:nth-child(2) {
      margin-left: -720px;
    }
    p:nth-child(3) {
      margin-left: -700px;
    }
    .h {
      text-align: center;
      color: #ffff;
      font-size: 10px;
    }
  }
}
</style>

